import { render, staticRenderFns } from "./Themes.vue?vue&type=template&id=4072c13a&scoped=true"
import script from "./Themes.vue?vue&type=script&lang=js"
export * from "./Themes.vue?vue&type=script&lang=js"
import style0 from "./Themes.vue?vue&type=style&index=0&id=4072c13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072c13a",
  null
  
)

export default component.exports